<div
    *ngIf="mapSettings$ | async; else tplLoading"
    style="height: 500px"
>
    <bazis-map
        [mapSettings$]="mapSettings$"
        [mapLayers$]="layers$"
        (popupAction)="reemitPopupAction($event)"
    ></bazis-map>
</div>

<ng-template #tplLoading>
    <bazis-skeleton [height]="500"></bazis-skeleton>
</ng-template>
